import React from "react";
import { FeatureModule } from "@/shared/types/routing";

// Lazy load components for code splitting
const Login = React.lazy(() => import("./Login"));
const Signup = React.lazy(() => import("./Signup"));
const ResetPassword = React.lazy(() => import("./ResetPassword"));
const RecoverUserId = React.lazy(() => import("./RecoverUserId"));
const DataProtectionDenied = React.lazy(() => import("./DataProtectionDenied"));

const AuthModule: FeatureModule = {
  name: "auth",
  routes: [
    {
      path: "/",
      element: <Login />,
      meta: {
        label: "Login",
        showInSidebar: false,
        requiresAuth: false,
      },
    },
    {
      path: "/login",
      element: <Login />,
      meta: {
        label: "Login",
        showInSidebar: false,
        requiresAuth: false,
      },
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
      meta: {
        label: "Reset Password",
        showInSidebar: false,
        requiresAuth: true,
        noSidebar: true,
      },
    },
    {
      path: "/signup",
      element: <Signup />,
      meta: {
        label: "Sign Up",
        showInSidebar: false,
        requiresAuth: false,
      },
    },
    {
      path: "/recover-userid",
      element: <RecoverUserId />,
      meta: {
        label: "Recover User ID",
        showInSidebar: false,
        requiresAuth: false,
      },
    },
    {
      path: "/signup/consent-denied",
      element: <DataProtectionDenied />,
      meta: {
        label: "Data Protection Consent Denied",
        showInSidebar: false,
        requiresAuth: false,
      },
    },
  ],
};

export default AuthModule; 